<div class="calc-val">
  <span class="calc-value" [innerHtml]="getCalculatedValue()"></span>
  <span *ngIf="field.templateOptions.fieldSuffix" [innerHtml]="field.templateOptions.fieldSuffix" class="form-text-suffix"></span>
</div>

<p class="margin-left">
  <strong>
    <span [innerHtml]="field.templateOptions.label"></span>
  </strong>
</p>